import { Card, IconButton, Table, Typography } from '@mui/joy';
import { useEffect, useState } from 'react';
import { RecentRound } from '../models/recent-round';
import { recentRoundsService } from '../services/recent-rounds-service';
import { useNavigate } from 'react-router';
import LaunchIcon from '@mui/icons-material/Launch';

const RecentRounds = () => {

    const [recentRounds, setRecentRounds] = useState<RecentRound[]>([]);
    useEffect(() => {
        const data = recentRoundsService.getRecentRounds();
        setRecentRounds(data);
    }, []);
    const navigate = useNavigate();

    const openRound = (roundId: string, playerId: string) => {
        navigate(`/${roundId}/${playerId}`);
    };

    return (
        <Card variant="outlined">
            <Table>
                <thead>
                <tr>
                    <th style={{ width: '40%' }}>Round</th>
                    <th style={{ width: '25%' }}>Date</th>
                    <th style={{ width: '25%' }}>Player</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {
                    recentRounds.map((round) => (
                        <tr key={round.roundId + '/' + round.playerId}>
                            <td>{round.roundName}</td>
                            <td>{round.roundDate ? new Date(round.roundDate + 'T00:00:00').toLocaleDateString() : ''}</td>
                            <td>{round.playerName}</td>
                            <td><IconButton
                                aria-label={`Open round ${round.roundName}`}
                                onClick={() => openRound(round.roundId, round.playerId)}><LaunchIcon /></IconButton>
                            </td>
                        </tr>
                    ))
                }
                </tbody>
            </Table>
        </Card>
    );
};


export default RecentRounds;